import React from 'react';
import { ArrowRight, Heart, Play } from 'lucide-react';
import { heroStats } from '../mock';

const Hero = () => {
  return (
    <section className="relative bg-white pt-10 pb-24 lg:pt-16 lg:pb-32 overflow-hidden">
      <div className="brush-swash w-64 h-16 top-24 -left-10" />
      <div className="brush-swash w-48 h-10 bottom-40 left-1/2" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#6e12ed]">Campaign 2026</span>
              <span className="w-8 h-px bg-[#6e12ed]" />
              <span className="text-xs uppercase tracking-[0.25em] font-semibold text-neutral-500">Take A Stand</span>
            </div>

            <h1 className="font-serif text-[46px] sm:text-6xl lg:text-[72px] leading-[1.02] text-[#0E1112] font-bold">
              Small charity.<br />
              <span className="hl-box hl-cyan">Mighty</span> stand.<br />
              <span className="hl-box hl-purple">Global</span> ripple.
            </h1>

            <p className="mt-7 text-neutral-700 text-lg leading-relaxed max-w-xl">
              “<em>We likkle but we tallawah</em>” — a Jamaican proverb meaning <em>small but mighty</em>.
              For 38 years, ACCI has quietly transformed mental health for African & Caribbean
              communities in the Black Country. Now we’re asking you to stand with us.
            </p>

            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <a
                href="#donate"
                className="inline-flex items-center justify-center gap-2 bg-[#6e12ed] hover:bg-[#5A0DCC] text-white font-semibold px-7 py-3.5 rounded-md transition-colors group"
              >
                <Heart className="w-4 h-4 fill-white" />
                Donate £5 a month
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href="#take-part"
                className="inline-flex items-center justify-center gap-2 border-2 border-[#79c4c7] text-[#0E1112] hover:bg-[#79c4c7] hover:text-white font-semibold px-7 py-3.5 rounded-md transition-colors"
              >
                <Play className="w-3.5 h-3.5 fill-current" />
                Ways to take part
              </a>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
              {heroStats.map((s, i) => (
                <div key={s.label} className={`${i > 0 ? 'pl-4 border-l border-black/10' : ''}`}>
                  <div className="font-serif text-3xl lg:text-4xl font-bold text-[#0E1112]">{s.value}</div>
                  <div className="text-xs text-neutral-600 mt-1 leading-tight">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6 relative">
            <div className="relative aspect-[4/5] max-w-lg mx-auto">
              <div className="absolute inset-0 rounded-[2rem] overflow-hidden shadow-xl">
                <img
                  src="https://images.unsplash.com/photo-1596510914965-9ae08acae566?w=900"
                  alt="Family standing together"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -top-6 -right-4 w-40 h-20 bg-[#F1D3B6] rounded-[50%] rotate-12 -z-10" />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-5 max-w-[220px] border border-black/5">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#79c4c7] flex items-center justify-center flex-shrink-0">
                    <Heart className="w-4 h-4 text-white fill-white" />
                  </div>
                  <div>
                    <div className="font-serif font-bold text-[#0E1112]">Est. 1987</div>
                    <div className="text-[11px] text-neutral-600">Recognised globally</div>
                  </div>
                </div>
              </div>
              <div className="absolute -top-4 -left-4 bg-[#6e12ed] text-white rounded-2xl p-4 shadow-lg">
                <div className="text-[10px] uppercase tracking-widest opacity-80">Serving</div>
                <div className="font-serif text-2xl font-bold">The Black Country</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
